const mediaItems = [
  {
    title: '某顶流深夜密会神秘女子引热议',
    views: '128.6w',
    duration: '03:24',
    tag: '独家',
    img: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20video%20thumbnail%20with%20warm%20coral%20tones%2C%20cinematic%20spotlight%20on%20abstract%20stage%20with%20red%20curtains%2C%20editorial%20aesthetic%2C%20dramatic%20mood%2C%20modern%20minimal%20composition&width=450&height=800&seq=media-thumb-1&orientation=portrait',
  },
  {
    title: '某综艺录制现场突发意外，全场哗然',
    views: '96.3w',
    duration: '05:11',
    tag: '热点',
    img: 'https://readdy.ai/api/search-image?query=Entertainment%20variety%20show%20studio%20scene%20with%20warm%20amber%20lighting%2C%20stage%20lights%20and%3B%20cameras%2C%20dramatic%20cinematic%20atmosphere%2C%20editorial%20style%2C%20modern%20clean%20composition&width=450&height=800&seq=media-thumb-2&orientation=portrait',
  },
  {
    title: '知名导演新片路透首曝光引期待',
    views: '87.9w',
    duration: '02:47',
    tag: '首发',
    img: 'https://readdy.ai/api/search-image?query=Film%20production%20set%20with%20warm%20coral%20and%3B%20golden%20accents%2C%20movie%20director%20aesthetic%2C%20behind%20the%20scenes%20cinematic%20lighting%2C%20editorial%20photography%20style%2C%20soft%20gradient%20overlay&width=450&height=800&seq=media-thumb-3&orientation=portrait',
  },
  {
    title: '某女星直播意外说漏嘴爆猛料',
    views: '156.2w',
    duration: '04:03',
    tag: '爆款',
    img: 'https://readdy.ai/api/search-image?query=Livestream%20studio%20with%20warm%20rosy%20lighting%2C%20ring%20light%20glow%2C%20modern%20streamer%20setup%20aesthetic%2C%20entertainment%20news%20vibe%2C%20editorial%20style%20with%20soft%20warm%20gradients&width=450&height=800&seq=media-thumb-4&orientation=portrait',
  },
  {
    title: '某剧组杀青花絮独家放送，粉丝炸锅',
    views: '72.4w',
    duration: '06:18',
    tag: '花絮',
    img: 'https://readdy.ai/api/search-image?query=Film%20crew%20wrap%20party%20celebration%20scene%20with%20warm%20golden%20amber%20tones%2C%20behind%20the%20scenes%20cinematic%20lighting%2C%20editorial%20photography%20aesthetic%2C%20joyful%20atmosphere&width=450&height=800&seq=media-thumb-5&orientation=portrait',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            吃瓜现场
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">热门吃瓜视频，直击娱乐第一现场</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group relative bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[9/16] bg-secondary-100 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between text-background-50 text-xs">
                  <span className="bg-black/50 px-2 py-0.5 rounded-full whitespace-nowrap">{item.duration}</span>
                  <span className="whitespace-nowrap">{item.views} 次播放</span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full whitespace-nowrap">{item.tag}</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/80 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-800 line-clamp-2 leading-snug">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}